'use client';

import { createContext, useContext } from 'react';

export interface DetectWebinappState {
  isWebinapp: boolean;
  hydrated: boolean;
}

export const DetectWebinappContext = createContext<DetectWebinappState>({
  isWebinapp: false,
  hydrated: false,
});

/**
 * `true` khi app đang chạy trong WebInApp mode (embed trong native app).
 * Detection do `DetectWebinappProvider` chạy MỘT lần ở root layout — consumers
 * chỉ subscribe vào state share.
 *
 * SSR và client first render trả `false` để tránh hydration mismatch.
 * Effect resolve ngay sau mount (cùng tick), nên flash gần như không thấy.
 * Dùng `useWebInAppHydrated()` nếu cần defer render (vd: render skeleton trước).
 */
export const useDetectWebInApp = (): boolean =>
  useContext(DetectWebinappContext).isWebinapp;

/**
 * `true` sau khi `DetectWebinappProvider` đã chạy effect detect
 * (đọc localStorage + URL params). Dùng cho consumer cần biết detection
 * đã resolve để chọn UI thật vs skeleton.
 */
export const useWebInAppHydrated = (): boolean =>
  useContext(DetectWebinappContext).hydrated;
